import type { SeparatorItemProps } from 'types';

const Separator: React.FC<SeparatorItemProps> = ({ type, index }) => (
  <span
    key={`${type}_separator_${index}`}
    // ! This line must be disabled, because it auto fixs it to `w-px` that should be 1px
    // !   but for some reason our apps are resolving it to 4px. in some pages its rendering
    // !   as 4px and in some pages as 1px. So we are using the arbitrary value to ensure
    // !   it always renders as 1px.
    // eslint-disable-next-line tailwindcss/no-unnecessary-arbitrary-value
    className="bg-color-ref-ui-divider-strong h-auto w-[1px]"
  />
);

export default Separator;
